import L, { Map as LeafletMap, LatLngBounds } from 'leaflet';
import { Component } from 'react';
import PropTypes from 'prop-types';
import Esri from 'esri-leaflet';
import svgIcon from '../customMarker.svg';

import './Custom.css';

export class CustomLayerComponent extends Component {

  static contextTypes = Component.contextTypes;
  static childContextTypes = Component.childContextTypes;
  static contextTypes = {
    map: PropTypes.instanceOf(LeafletMap),
  };

  constructor(props) {
    super(props);
    this.state = {
      feature: null,
      loaded: null,
    };
    this.addLabels = this.addLabels.bind(this);
  }

  componentDidMount() {
    const feature = this.getEsriFeature();

    feature.addTo(this.context.map);
  }

  componentDidUpdate(previous) {
    const { shapefile } = this.props;

    if (previous.shapefile !== shapefile) {
      this.context.map.removeLayer(this.state.feature);

      const feature = this.getEsriFeature();
      feature.addTo(this.context.map);
    }
  }

  componentWillUnmount() {
    if (this.state.feature && this.state.feature.remove && this.state.feature._map) {
      this.state.feature.remove();
    }
  }

  getEsriFeature() {
    const { shapefile, onBoundsUpdate, setViewerPolygon } = this.props;

    if (setViewerPolygon) setViewerPolygon(shapefile.arcId);

    const { customURL, fillColor, fillOpacity, lineColor, id, label, pointColor } = shapefile;
    const url = customURL ||
      `https://services2.arcgis.com/g0Pkas6by3743iav/arcgis/rest/services/${id}/FeatureServer/0`;
    const bounds = new LatLngBounds();
    const labels = {};
    const pane = this.context.map.createPane(url);

    const feature = Esri.featureLayer({
      url,
      style: {
        weight: 1,
        color: lineColor,
        fillColor,
        fillOpacity,
        fill: true,
      },
      pointToLayer(f, latlng) {
        const icon = encodeURI(`data:image/svg+xml,${svgIcon}`)
          .replace('#FF8000', pointColor)
          .split('#').join('%23');

        if (f.geometry.type === 'Point') {
          if (label) {
            const name = f.properties[label];
            const address = f.properties.Address_1 || f.properties.City || f.properties.State || f.properties.Zip ? `${f.properties.Address_1 || ''} ${f.properties.City || ''}, ${f.properties.State || ''} ${f.properties.Zip || ''}` : '';
            const customPopup = `<b>${name}</b><br/><p>${address}</p>`;
            const customOptions = {
              className: 'customLabelPopup',
            };
            return L.marker(latlng, {
              pane,
              icon: L.icon(
                {
                  iconUrl: icon,
                  iconSize: [26, 35],
                  iconAnchor: [13, 36],
                },
              ),
            }).bindPopup(customPopup, customOptions).openPopup();
          }
        }

        return L.marker(latlng, {
          pane,
          icon: L.icon(
            {
              iconUrl: icon,
              iconSize: [26, 35],
              iconAnchor: [13, 36],
            },
          ),
        });
      },
      onEachFeature: (f, l) => {
        if (f.geometry.type !== 'Point') {
          if (label) {
            this.addLabels(f, l, label, labels);
          }
          bounds.extend(l.getBounds());
        }
      },
    });

    feature.once('load', () => {
      this.setState({ feature });
      feature.query().bounds((error, latlngbounds) => {
        onBoundsUpdate(latlngbounds);
      });
    });

    feature.on('removefeature', e => {
      const labelName = labels[e.feature.id];
      if (labelName) {
        this.context.map.removeLayer(labelName);
      }
      pane.remove();
    });

    return feature;
  }

  addLabels(feature, layer, label, labels) {
    const center = layer.getBounds().getCenter();
    const marker = L.marker(center, {
      icon: L.divIcon({
        iconSize: null,
        className: 'custom-layer__label',
        zIndexOffset: 200,
        html: `<div>${feature.properties[label]}</div>`,
      }),
      zIndexOffset: 200,
    }).addTo(this.context.map);
    // eslint-disable-next-line
    labels[feature.id] = marker;
  }

  render() {
    return null;
  }
}

CustomLayerComponent.contextTypes = {
  map: PropTypes.instanceOf(LeafletMap),
};

CustomLayerComponent.propTypes = {
  onBoundsUpdate: PropTypes.func,
  shapefile: PropTypes.object,
  setViewerPolygon: PropTypes.func,
};

export default CustomLayerComponent;



// WEBPACK FOOTER //
// ./src/components/Map/Layers/Custom.js